import script from "./AdminContact.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminContact.vue?vue&type=script&setup=true&lang=js"

import "./AdminContact.vue?vue&type=style&index=0&id=659cd83d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-659cd83d"]])

export default __exports__